module.exports = __webpack_public_path__ + "img/it-1.d8bc4c86.png";